export default __webpack_public_path__ + "static/media/riddler_logo.1822fe74.svg";